define(function () {
  return {
    // CALL CENTER USER
    'call_center.register': "登记另一用户",

    'incrowd_stats.num_responders': "{{num}}名医疗保健专业人士",
    'incrowd_stats.num_answers': "已回答{{num}}个问题",
    'incrowd_stats.time_to_complete': "完成调查平均需要{{num}}分钟",

    // INCROWD
    'incrowd.about': "关于",
    'incrowd.contact': "联系",
    'incrowd.press': "媒体",
    'incrowd.careers': "就业",
    'incrowd.terms': "条款",
    'incrowd.t_and_c': "条款和条件",
    'incrowd.faq': "常问问题",
    'incrowd.privacy': "隐私",
    'incrowd.copyright': "{{year}} InCrowd公司，版权所有",
    'incrowd.blog': "博客",
    'incrowd.support': "支持",
    'incrowd.info.ios': "您知道吗，在InCrowd网络中的医生，现在可以直接将问题发送给自己的同事？现在就来试用<InCrowd iOS App>！",
    'incrowd.refer': "喜欢做我们的调查吗？今天<推荐一位朋友>加入我们，你俩就能获得10美元（或等值）。一旦你的同事的完成了调查，他们还将获得奖励！",

    // GET STARTED (step 0)
    'getstarted.encourage.title': "微小调研，",
    'getstarted.encourage.title.two': "巨大影响",
    'getstarted.encourage.subtitle': "通过简单的微调研，加入影响的新产品和患者治疗发展的、数以千计的合格的医疗专业人士行列，我们还会付款给您！",
    'getstarted.encourage.redirect_to_solutions': "不是医疗专家但想更多了解InCrowd吗？",
    'getstarted.actions.title': "你是合格的医疗专业人士吗？",
    'getstarted.actions.subtitle': "立即注册，开始回答医疗保健微调研，并赚取报酬",
    'getstarted.button.continue': "开始",
    'getstarted.referral': "注册以从调查问卷中赚钱，另加您来自 %{{referrerName}} 的推荐奖金",
    'getstarted.complete_registration': " Complete your InCrowd registration and start receiving surveys today!",
    'getstarted.questions': "Have questions? Use the chat box on the bottom right of the screen, we're here to help.",

    'details.need_info_description': "我们需要您的一些详细信息来设置您的账户。",
    'details.profile_details': "个人资料详情",
    'details.address_information': "地址信息",
    'details.professional_info': "专业信息",
    'details.heading.finally': "…然后，终于",
    'details.how_receive_surveys': "您想如何收到调查？",

    // PROFESSION CHOICE (step 1)
    'professionchoice.encourage.title': "基本事项",
    'professionchoice.encourage.subtitle': "没有看到您的职业？让在<这里>告知我们，以确保当我们增加了您的专业时，会通知您。",
    // AUTHENTICATION INFORMATION (step 2)
    'authentication.encourage.title': "您是谁？",
    'authentication.encourage.subtitle': "InCrowd需要验证您的身份，但我们绝不会将您的个人信息泄露或分发提供给第三方。",
    'authentication.actions.select_notifications': "选择您想要收到我们的调查的方式",
    // VALIDATE IDENTITY (step 3)
    'validation.please_wait': "请稍候，我们正在确认您信息",
    'validation.please_answer': "请回答以下问题，帮助我们确认您的个人信息",
    // CONFIRMATION (final step)
    'confirmation.validation_success.title': "确认",
    'confirmation.validation_success.subtitle': "您的注册已经完成，欢迎来到 InCrowd！您稍后将通过电子邮件和／或短信收到确认。感谢您的加入！",
    'confirmation.validation_error.title': "需要更多信息",
    'confirmation.validation_error.subtitle': "抱歉，%{userFirstName},验证您的个人信息时出现一个问题。",
    'confirmation.actions_title': "下一步?",
    'confirmation.go_to_your_profile': "进入您的个人资料",
    'confirmation.validation_success.actions_subtitle': "您将在几天内通过电子邮件或短信收到我们3 - 5分钟的微型调查。还没有选择通过短信接收调查问卷？您随时可从您的 InCrowd 个人资料中更改您的通信设置。",
    'confirmation.validation_error.actions_subtitle': "请使用屏幕右下角弹出的聊天窗口与InCrowd团队成员交谈和解决任何尚未解决的问题。",
    'confirmation.referral.info.1': "在您完成第二份问卷的 %{payoutBusinessDays} 工作日内，您和您的推荐人， <将每人收到 %{currency}%{referralBonusAmount}>。 %{currency}%{referralBonusAmount} 将被添加支柱您的奖励账户。您可以在任何时间登入您的 <个人资料> 以更新偏好、查看您的奖励，或者进入您被邀请的任何开放问卷调查中。",
    'confirmation.referral.info.2': "有疑问？ <与我们聊天>",

    // REGISTRATION FOOTER
    'regftr.qualified.title': "您有资格吗?",
    'regftr.markets.accepting': "InCrowd Answers目前正在接收：",
    'regftr.peers.title': "同行",
    'regftr.peers.subtitle': "将您的回答与同行的回答进行比较，并从他们的回答中学到东西。",
    'regftr.invites.title': "邀请",
    'regftr.invites.subtitle': "通过电子邮件或手机获取新的调查邀请，使您的收入最大化。",
    'regftr.earnings.title': "收入",
    'regftr.earnings.subtitle': "管理和跟踪您的收入及付款信息。",
    'regftr.stats.title': "统计",
    'regftr.stats.subtitle': "访问显示所有调查信息和用户详细信息的面板。",

    'contextual_help.sms': "有开放微调查时，您将收到短信通知。通过短信，您将可以更加快速地进入调查并且赚更多奖励。我们会对您的信息保密，并且仅将它们用于发送调查邀请的目的。",
    'contextual_help.specialty': "仅请填写与您的NPI相关的专业，您已在属于自己主要专业的医学领域获得奖学金。如果您将来需要改变自己的专业，请联系support@incrowdnow.com。",
    // USER
    'user(s)': "用户 |||| 用户",
    'user.login': "登入",
    'user.logout': "登出",
    'user.register': "注册",
    'user.invitations': "邀请",
    'user.email': "电子邮件",
    'user.pass_word': "密码",
    'user.mobile': "手机",
    'user.mobile.hint': "请包括国家代码 (%{countryName}的+%{phoneCode})",
    'user.title': "头衔",
    'user.title_with_example': "头衔 (例如：博士，女士，先生)",
    'user.first_name': "名",
    'user.last_name': "姓",
    'user.middle_name': "中间名字",
    'user.full_name': "%{firstName} %{lastName}",
    'user.full_name_and_title': "%{title} %{firstName} %{lastName}",
    'user.first_name_last_initial': "%{firstName} %{lastInitial}.",
    'user.anonymous': "A用户",
    'user.anonymous_admin': "管理员用户",
    'user.dashboard': "仪表盘",
    'user.profile': "简介",
    'user.profile.picture.upload': "上传个人资料图片",
    'user.profile.picture.change': "更改",
    'user.primary_lang': "主要语言",
    'user.primary_lang?': "您的主要语言是什么？",
    'user.survey_langs?': "您能流利使用哪些语言？",
    'user.notify_email': "通过电邮通知",
    'user.notify_mobile': "通过手机通知",
    'user.contact_support': "联系支持",
    // SATURN-9
    'user.contact_trouble': "Having trouble? Contact us below:",
    'user.contact_email': "Send us an email",
    // end SATURN-9
    'user.please_contact_us': "请 <联系我们>.",
    'user.profession': "职业",
    'user.profession?': "您的职业是什么？",
    'user.join_now': "现在加入",
    'user.welcome_back': "欢迎回来！",
    'user.not_a_member?': "还不是会员？",
    'user.accept_terms': "接受条款",
    'user.accept_terms.yes': "我接受<条款和条件>",
    'user.remember_me': "请在此设备上提醒我",
    'user.time_zone': "时区",
    'user.payment.policy': "每次您在奖励中达到 %{currency}25时，都会收到通知，并且可以通过您的 InCrowd 个人资料从我们的付款选项中进行选择。有疑问？通过下方的聊天窗口联系我们。",
    'user.country.live_work?': "您在哪个国家生活和工作？",
    // FORMS
    'form.button.back': "后退",
    'form.button.next': "下一个",
    'form.button.cancel': "取消",
    'form.button.submit': "提交",
    'form.button.continue': "继续",
    'form.button.close': "关闭",
    'form.button.go!': "运行！",
    'form.button.complete!': "现在完成！",
    'form.button.update': "更新",
    'form.button.finish': "完毕",
    'form.button.search': "搜索",
    'form.button.end': "结束",
    'form.search.no_matches': "没有找到匹配内容",
    'form.confirm_email': "确认电子邮件",
    'form.confirm_pass_word': "确认密码",
    'form.required_fields': "必填项",
    'form.nothing_selected': "没有选择任何项",
    'form.confirm_field': "确认 %{formFieldLabel}",
    'form.choice.n/a': "不适用",
    'form.choice.yes': "是",
    'form.choice.no': "不是",
    'form.choice.blank_for_all': "保留为空以全选",
    'form.choices.select_all': "全选",
    'form.choices.deselect_all': "取消全选",
    'form.field.private': "私人领域",

    // USER ERRORS
    'user.error.dup_email': "其他用户已使用该指定电子邮件地址注册。<顶替登入？>",
    'user.error.dup_sms': "另一个用户已经与给定的手机号码注册",
  }
})
